// @flow
import type { OverActionType } from '../../types';

export function openOverlay(overlayAction: OverActionType) {
  return {
    type: 'OPEN_OVERLAY',
    overlayAction
  };
}

export function closeOverlay() {
  return {
    type: 'CLOSE_OVERLAY'
  };
}
